// See ./CLAUDE.md for the full spec.

export enum BannerWidth {
  Full = 'full',
  Inset = 'inset',
}

export enum Spacing {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export const DEFAULT_BANNER_WIDTH: BannerWidth = BannerWidth.Full;
export const DEFAULT_SPACING: Spacing = Spacing.Medium;
